import React, { useEffect } from "react";
import styles from './not_found.module.css';
import { Link, useLocation } from "react-router-dom";
import { setMetaTags, getDataFromRoutes } from "../../utils/util_functions";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { useDispatch } from "react-redux";
import { ROUTES_CONST } from "../../utils/constants";


function NotFound() {

  const location = useLocation();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    // eslint-disable-next-line
  }, [location]);

  const {
    title, metaTitle
  } = getDataFromRoutes(location.pathname, ROUTES_CONST);

  useEffect(() => {
    setMetaTags(metaTitle);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {window.scrollTo({top: 0, left: 0})}, []);

  return (
    <main className='main'>
      <h1 className='title'>{title}</h1>
      <p className={styles.text__gray}>
        Эта страница устарела или никогда не существовала.
      </p>
      <Link to='/' className={styles.link} replace={true}>На главную</Link>
    </main>
  );
}

export default NotFound;
